/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-02 18:08:26
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-03-15 14:32:11
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/tools.ts
 */
import { get, max, min } from 'lodash';
import { handleOnFormatStoreTimeAndDateWithTimezone } from 'src/tools/tools';
export enum EExternalRef {
  setUuid = '_setUuid',
  customizationDisplay = '_customizationDisplay',
  isChild = '_isChild',
  isParent = '_isParent',
  isLast = '_isLast',
}

const getSubItems = (data, uuid) => {
  const _self = (data || []).find((i) => i.uuid === uuid) || {};
  const _sub =
    (data || []).filter((i) => i[EExternalRef.setUuid] === uuid) || [];
  return {
    set: _self,
    simple: _sub,
  };
};

const getMinSetNumber = (items) => {
  let isEntireSet = true;
  const minNumArr = (items || []).map((item) => {
    const quantity = get(item, 'quantity') || 0;
    const unitAmount = get(item, 'unitAmount') || 1;
    const _a = Math.floor(quantity / unitAmount);
    if (isEntireSet) {
      const isFullyDivided = quantity % unitAmount === 0;
      if (!isFullyDivided) {
        isEntireSet = false;
      }
    }
    return _a;
    //const quantity = get(item, 'quantity') || 0;
  });
  const minNumber = min(minNumArr);
  const maxNumber = max(minNumArr);
  const _isEntire = isEntireSet && minNumber === maxNumber;
  return { min: minNumber, isEntireSet: _isEntire };
};

const breadcrumbData = (orderNo, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/orderList',
    name: getI18n('general.sider.allOrders'),
  },
  {
    url: '',
    name: `#${orderNo}`,
  },
];

const getMaxTimeline = (timelines, status?: any) => {
  const timeMaxTime = (timelines || [])
    .filter((o) => (status ? o.status === status : true))
    .reduce((p, c) => {
      if (c && c.timestamp > p) {
        return c.timestamp;
      }
      return p;
    }, -Infinity);

  if (timeMaxTime === -Infinity) {
    return '';
  }
  return handleOnFormatStoreTimeAndDateWithTimezone(timeMaxTime);
};

export { breadcrumbData, getMaxTimeline, getMinSetNumber, getSubItems };
